import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Components
import TestimonialBox from "../Elements/TestimonialBox";

export default function TestimonialSlider() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <Slider {...settings}>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="400+ Work Force, including well trainned & equipped Site Engineers and highly experience Back Office staff."
            author=""
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="More than 25,000 2G, 3G, LTE/4G integrated and 5G sites commissioned and counting, across various networks."
            author=""
          />
        </LogoWrapper>

        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="Over 500,000 pieces of telecom technical equipment have been successfully deployed across various networks."
            author=""
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="400+ Work Force, including well trainned & equipped Site Engineers and highly experienced Back Office staff."
            author=""
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="More than 25,000 2G, 3G, LTE/4G integrated and 5G sites commissioned and counting, across various networks."
            author=""
          />
        </LogoWrapper>
      </Slider>
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 100%;
  padding: 0 8px 12px;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;
